import { Color } from "@mui/material";
import { blue, purple } from "@mui/material/colors";
import { MetricsKey } from "@/components/pages/common/resources-ag-grid/utils/metrics/metricsTypes";

export const colorsByMetricType = new Map<MetricsKey, Color>([
  ["memory_used_bytes", purple],
  ["memory_used_percent", purple],
  ["mem_used_percent_max", purple],
  ["mem_available_percent_min", purple],
  ["cpu_max", blue],
  ["cpu_cores", blue],
  ["cpu_percent", blue],
  ["total_connection_sum", blue],
  ["all_request_sum", blue],
  ["processed_bytes", blue],
]);

export const metricCellFrequencyValues: Record<string, "hourly" | "daily"> = {
  "24h": "hourly",
  "7d": "daily",
  "30d": "daily",
};

export const metricsLabel: Record<MetricsKey, string> = {
  cpu_max: "Max CPU",
  cpu_cores: "Max CPU",
  cpu_percent: "Max CPU",
  total_connection_sum: "Connections",
  all_request_sum: "Requests",
  memory_used_bytes: "Memory Max",
  memory_used_percent: "Memory Max",
  mem_used_percent_max: "Memory Max",
  mem_available_percent_min: "Unused Memory",
  processed_bytes: "Traffic Sum",
};

export const metricsUnit: Record<MetricsKey, string> = {
  cpu_max: "%",
  cpu_cores: "%",
  cpu_percent: "%",
  total_connection_sum: "Connections",
  all_request_sum: "Requests",
  memory_used_bytes: "%",
  memory_used_percent: "%",
  mem_used_percent_max: "%",
  mem_available_percent_min: "%",
  processed_bytes: "Mb",
};
